// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import ProfileActions from './data'

export default function ProfileActionsFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/ProfileActions">
      <ProfileActions {...props}>
        {children}
      </ProfileActions>
    </Flow>
  )
}
